import theme from '../assets/styles/chakra-theme';
import { ChakraProvider } from '@chakra-ui/react';
import { Outlet, useLocation } from 'react-router-dom';
import registrationTheme from './registration/chakra-theme';

export const ThemeProvider: React.FC = () => {
  const location = useLocation();
  const isRegistration =
    location.pathname === '/mathnation/login/preview/registration' ||
    location.pathname === '/mathnation/login/adoption/registration';

  return (
    <ChakraProvider theme={isRegistration ? registrationTheme : theme}>
      <Outlet />
    </ChakraProvider>
  );
};
